export default __webpack_public_path__ + "static/media/trenza-negro.3c84db24.png";